<template>
  <div
    :class="[
      'subscribe',
      {
        'subscribe--dark': isSubscribeDarkTheme,
        'subscribe--alone': isStandalone
      }
    ]"
  >
    <p v-if="hasTitle" class="subscribe__title">{{ $t('SUBSCRIBE_TITLE') }}</p>

    <sc-rich-text
      v-if="isStandalone"
      tag="div"
      class="subscribe__desc"
      :field="descriptionField || {}"
    />
    <i18n
      v-else
      tag="p"
      class="subscribe__desc"
      path="SUBSCRIBE_DETAIL"
    >
      <a :href="$t('SUBSCRIBE_LINK')">{{ $t('SUBSCRIBE_LINK_TEXT') }}</a>
    </i18n>

    <sh-button
      class="subscribe__btn"
      :color="btnColor"
      :[btnStyle]="true"
      @click="openSubscribeDialog"
    >
      {{ $t('SUBSCRIBE_SUBMIT') }}
    </sh-button>
  </div>
</template>

<script>
import { ShButton } from '@sohohouse/design-system'
import { RichText as ScRichText } from '@sitecore-jss/sitecore-jss-vue'

import getButtonStyle from '~/helpers/get-button-style'
import CTA from '~/constants/appearance'
import { FORM, EVENT } from '~/constants/analytics'
import UIMixin from '~/mixins/ui'
import { THEME } from '~/constants'

export default {
  name: 'Subscribe',

  components: {
    ShButton,
    ScRichText
  },

  inject: ['theme'],

  props: {
    isStandalone: {
      type: Boolean,
      default: false
    },

    hasTitle: {
      type: Boolean,
      default: true
    },

    descriptionField: {
      type: Object,
      required: false
    },

    ctaAppearance: {
      type: String,
      required: false
    }
  },

  mixins: [UIMixin],

  computed: {
    isSubscribeDarkTheme () {
      return this.theme && this.theme.color === THEME.Dark
    },

    btnColor () {
      return this.isSubscribeDarkTheme ? CTA.secondary : CTA.primary
    },

    btnStyle () {
      return getButtonStyle(this.ctaAppearance)
    }
  },

  methods: {
    openSubscribeDialog () {
      this.$ui.modal.open('subscribe-dialog-modal')
      this.$analytics.push({
        event: EVENT.FORM_LOAD,
        form: {
          id: FORM.NEWSLETTER
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.subscribe {
  a {
    white-space: nowrap;
  }

  &__title {
    @include font('070');
    @include stack-space($space-020);

    @include tablet {
      @include font('060');
    }
  }

  &__desc {
    @include font('050');
    @include stack-space($space-050);

    @include tablet {
      @include stack-space($space-040);
    }
  }

  &__btn {
    width: fit-content;
  }

  &--dark &__title,
  &--dark &__desc,
  &--dark a {
    color: $color-white;
  }

  &--alone {
    @include tablet {
      text-align: center;
    }
  }

  &--alone &__title {
    @include font('080');

    @include tablet {
      @include font('090');
    }
  }

  &--alone &__desc {
    @include font('050');
    @include stack-space($space-060);

    @include tablet {
      @include font('070')
    }
  }
}
</style>
